<template>
  <div v-if="fetchComplete">
    <v-card class="mx-auto" outlined elevation="4">
      <v-container>
        <v-row class="px-10 mb-n10">
          <v-col cols="12">
            <v-card-title class="accent-1 mt-n4">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-tooltip
                    top
                    v-if="
                      initiatorRoute.warningStatus == true &&
                        initiatorRoute.status != 'Done' &&
                        initiatorRoute.overdue_status != true
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span v-on="on" v-bind="attrs">
                        <v-icon
                          color="yellow darken-3"
                          class="mr-2 ml-n8 mb-1"
                          slot="activator"
                        >
                          mdi-alert-circle-outline
                        </v-icon>
                      </span>
                    </template>
                    <span>Route Near Due</span>
                  </v-tooltip>

                  <v-tooltip top v-else-if="initiatorRoute.status == 'Done'">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-on="on" v-bind="attrs">
                        <v-icon
                          color="green darken-1"
                          class="mr-2 ml-n8 mb-1"
                          slot="activator"
                        >
                          mdi-check-circle-outline
                        </v-icon>
                      </span>
                    </template>
                    <span>Route Completed</span>
                  </v-tooltip>

                  <v-tooltip top v-else-if="initiatorRoute.overdue_status">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-on="on" v-bind="attrs">
                        <v-icon
                          color="orange"
                          class="mr-2 ml-n8 mb-1"
                          slot="activator"
                        >
                          mdi-alert-circle-outline
                        </v-icon>
                      </span>
                    </template>
                    <span>Route Overdue</span>
                  </v-tooltip>

                  <v-badge
                    v-else
                    dot
                    left
                    class="mr-4"
                    color="indigo"
                  ></v-badge>

                  <h3
                    class="h2 mr-4 indigo--text darken-3 font-weight-bold"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ initiatorRoute.subject }}
                  </h3>
                </template>
                <span>Route Subject</span>
              </v-tooltip>
              <v-spacer></v-spacer>
              <p class="my-0 font-weight-regular body-2 indigo--text">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{
                        computedStatuses.length > 0
                          ? computedStatuses[statuses.length - 1].name
                          : ""
                      }}
                    </span>
                  </template>
                  <span>Current Route Status</span>
                </v-tooltip>
                <!-- <v-icon
                  color="indigo"
                  fab
                  small
                  depressed
                  @click="updateStatus()"
                  style="pointer: cursor"
                  class="mr-4"
                >
                  mdi-pencil
                </v-icon> -->
              </p>
              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn light icon v-bind="attrs" v-on="on" class="mr-n10">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item v-if="initiatorRoute.commentAccessConfig">
                    <v-list-item-content>
                      <v-list-item-title
                        class="list-item"
                        @click="openRouteComments()"
                      >
                        <v-icon class="mr-3" small>mdi-message-text</v-icon>
                        {{ route_comment_dialog ? "Close " : "Open " }} Route
                        Comments
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <!-- <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title class="list-item" @click="addRouteDocument(initiatorRoute.id)">
                            <v-icon class="mr-3" small>mdi-file-upload-outline</v-icon>
                            Upload Document
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item> -->

                  <v-list-item v-if="initiatorRoute.status == 'Pending'">
                    <v-list-item-content>
                      <v-list-item-title
                        class="list-item"
                        @click="addSubRoute(initiatorRoute.id)"
                      >
                        <v-icon class="mr-3" small>mdi-account-plus</v-icon>
                        Assign Route To Regional Employee
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <!-- <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            class="list-item"
                            @click="updateRouteDetails(initiatorRoute.id)"
                          >
                            <v-icon class="mr-3" small>mdi-pencil</v-icon>
                            Update Route Details
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item> -->

                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title
                        class="list-item"
                        @click="seeTransactionLog(initiatorRoute.id)"
                      >
                        <v-icon class="mr-3" small>mdi-clipboard-text</v-icon>
                        Route Tracking Details
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item v-if="initiatorRoute.status == 'Pending'">
                    <v-list-item-content>
                      <v-list-item-title
                        class="list-item"
                        @click="updateRouteCompeleted(initiatorRoute.id)"
                      >
                        <v-icon class="mr-3" small>mdi-check</v-icon>
                        Route Completed
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-title>
            <v-card-subtitle class="indigo--text">
              <v-row class="mt-n6 mb-n8">
                <v-col cols="12" class="mb-n4">
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <span class="mr-1" v-bind="attrs" v-on="on">
                        <v-icon small color="indigo" class="pb-1 mr-2"
                          >mdi-account</v-icon
                        >
                        {{ initiatorRoute.user.first_name }}
                        {{ initiatorRoute.user.middle_name }}
                        {{ initiatorRoute.user.last_name }}
                      </span>
                    </template>
                    <span>Initiator</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" class="mb-n4">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                        class="grey--text text--darken-3"
                      >
                        <v-icon
                          small
                          class="d-inline mr-3"
                          color="grey darken-3"
                        >
                          mdi-calendar-clock
                        </v-icon>
                        <DateCountdown
                          :routeId="initiatorRoute.id"
                          :routeType="'mainroute'"
                          :date="initiatorRoute.datetime_due.toString()"
                          :showCaption="false"
                          :currentStatus="computedStatusColor"
                          :accessRoutesList="'mainroute'"
                          :showDate="true"
                          :isWarned="initiatorRoute.isWarned"
                          :onlyHeader="false"
                          :isOverdued="initiatorRoute.overdue_status"
                          @emitWarning="routeWarning"
                        />
                      </span>
                    </template>
                    <span>Route Due</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12">
                  <!-- <v-tooltip top>
                    <template
                      v-slot:activator="{ on, attrs }"
                      v-if="initiatorRoute.commentAccessConfig"
                    >
                      <span
                        v-bind="attrs"
                        v-on="on"
                        :class="{
                          'grey--text text--darken-3': !route_comment_dialog,
                          'indigo--text': route_comment_dialog,
                        }"
                        @click="route_comment_dialog = !route_comment_dialog"
                      >
                        <v-icon
                          small
                          :color="
                            !route_comment_dialog ? 'grey darken-3' : 'indigo'
                          "
                          class="mr-2"
                        >
                          mdi-message-text-outline
                        </v-icon>
                        Comments ({{ initiatorRoute.route_comments.length }})
                      </span>
                    </template>
                    <span>See comments</span>
                  </v-tooltip> -->
                </v-col>
              </v-row>
            </v-card-subtitle>
            <v-card-subtitle>
              <v-container fluid class="ml-n2">
                <v-row class="mt-n4 mb-n4">
                  <v-col class="mb-n2" cols="6">
                    <p
                      class="
                        font-weight-regular
                        body-2
                        grey--text
                        text--darken-3
                      "
                    >
                      Main Document:
                    </p>
                  </v-col>
                  <v-col class="mb-n2" cols="6">
                    <p
                      class="
                        my-0
                        font-weight-regular
                        body-2
                        grey--text
                        text--darken-3
                      "
                    >
                      Supporting Documents:
                    </p>
                  </v-col>
                  <v-col cols="6" class="mt-n4">
                    <div
                      class="records-list"
                      v-for="document in selectedDocuments"
                      :key="document.id"
                      style="display: inline"
                    >
                      <v-menu
                        bottom
                        offset-x
                        origin="center center"
                        transition="scale-transition"
                        v-if="document.document_route[0].isMainDocument"
                      >
                        <template v-slot:activator="{ on }">
                          <v-tooltip top>
                            <template #activator="{ on: onTooltip }">
                              <v-badge
                                class="mt-n16"
                                dot
                                color="red"
                                overlap
                                v-if="document.document_route[0].isMainDocument"
                              >
                                <v-icon
                                  v-on="getHandlers(on, onTooltip)"
                                  light
                                  dense
                                  large
                                  color="indigo"
                                  >mdi-file-document-outline</v-icon
                                >
                              </v-badge>
                            </template>
                            <span>
                              <v-row style="width: 500px">
                                <v-col cols="12">
                                  <v-simple-table dense>
                                    <template v-slot:default>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <span
                                              class="
                                                indigo--text
                                                font-weight-bold
                                              "
                                              >Sender:</span
                                            >
                                            {{ document.document.sender }}
                                          </td>
                                          <td>
                                            <span
                                              class="
                                                indigo--text
                                                font-weight-bold
                                              "
                                              >Type:</span
                                            >
                                            {{
                                              document.document.document_type
                                                ? document.document
                                                    .document_type.name
                                                : "none"
                                            }}
                                          </td>
                                        </tr>
                                        <!-- <tr>
                                              <td>
                                                <span
                                                  class="indigo--text font-weight-bold"
                                                  >Title:</span
                                                >
                                                {{ document.document.title }}
                                              </td>
                                              
                                            </tr>
                                            <tr>
                                              <td colspan="2">
                                                <span
                                                  class="indigo--text font-weight-bold"
                                                  >Address:</span
                                                >
                                                {{ document.document.address }}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <span
                                                  class="indigo--text font-weight-bold"
                                                  >For:</span
                                                >
                                                {{ document.document.for }}
                                              </td>
                                              <td>
                                                <span
                                                  class="indigo--text font-weight-bold"
                                                  >Source:</span
                                                >
                                                {{ document.document.source }}
                                              </td>
                                            </tr> -->
                                        <tr>
                                          <td>
                                            <span
                                              class="
                                                indigo--text
                                                font-weight-bold
                                              "
                                              >Subject:</span
                                            >
                                            {{ document.document.subject }}
                                          </td>
                                          <td>
                                            <span
                                              class="
                                                indigo--text
                                                font-weight-bold
                                              "
                                              >Date Uploaded:</span
                                            >
                                            {{
                                              formatDocumentDate(
                                                document.document.date_uploaded
                                              )
                                            }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colspan="2">
                                            <span
                                              class="
                                                indigo--text
                                                font-weight-bold
                                              "
                                              >File URL:</span
                                            >
                                            {{ document.document.filepath_url }}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </template>
                                  </v-simple-table>
                                </v-col>
                              </v-row>
                            </span>
                          </v-tooltip>
                        </template>
                        <v-list>
                          <!-- <v-list-item class="menu-item" v-if="parentRouteId">
                                <v-list-item-title @click="attachRouteToParent(document)">Attach Document To Upper Route</v-list-item-title>
                              </v-list-item> -->
                          <v-list-item
                            class="menu-item"
                            @click="openDocumentVersionDialog(document)"
                          >
                            <v-list-item-title
                              >Upload New Version</v-list-item-title
                            >
                          </v-list-item>
                          <v-list-item
                            class="menu-item"
                            @click="
                              viewDocument(
                                `${fileSystemUrl}/view/${document.filepath_url}`
                              )
                            "
                          >
                            <v-list-item-title>View Document</v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            class="menu-item"
                            @click="deleteOutputDocument(document.id)"
                          >
                            <v-list-item-title
                              >Delete Document</v-list-item-title
                            >
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                    <!-- <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          style="cursor: pointer"
                          class="mx-1 my-1 ml-4 mt-2"
                          light
                          dense
                          color="grey lighten-1"
                          v-on="on"
                          v-bind="attrs"
                          @click="addRouteDocument(initiatorRoute.id)"
                          v-if="initiatorRoute.uploadDocumentConfig"
                        >
                          mdi-plus-circle
                        </v-icon>
                      </template>
                      <span>Add Document</span>
                    </v-tooltip> -->
                  </v-col>
                  <v-col cols="6" class="mt-n4">
                    <div class="d-inline">
                      <div
                        class="records-list"
                        v-for="document in getListSupportingDocuments"
                        :key="document.id"
                        style="display: inline"
                      >
                      <v-menu
                          bottom
                          offset-x
                          origin="center center"
                          transition="scale-transition"
                        >
                          <template v-slot:activator="{ on }">
                            <v-tooltip top>
                              <template #activator="{ on: onTooltip }">
                                <v-badge
                                  class="mt-n16"
                                  dot
                                  color="white"
                                  overlap
                                >
                                  <v-icon
                                    v-on="getHandlers(on, onTooltip)"
                                    large
                                    class="mx-1"
                                    color="indigo"
                                  >
                                    mdi-file-document-outline
                                  </v-icon>
                                </v-badge>
                              </template>

                              <span>
                                <v-row style="width: 500px">
                                  <v-col cols="12">
                                    <v-simple-table dense>
                                      <template v-slot:default>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <span
                                                class="
                                                  indigo--text
                                                  font-weight-bold
                                                "
                                                >File name:</span
                                              >
                                              {{ document.filepath_url}}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td colspan="2">
                                              <span
                                                class="
                                                  indigo--text
                                                  font-weight-bold
                                                "
                                                >Date uploaded:</span
                                              >
                                              {{
                                                formatDocumentDate(document.date_uploaded)
                                              }}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </template>
                                    </v-simple-table>
                                  </v-col>
                                </v-row>
                              </span>
                            </v-tooltip>
                          </template>
                          <v-list>
                            <v-list-item
                              class="menu-item"
                            >
                              <v-list-item-title
                                >Upload New Version</v-list-item-title
                              >
                            </v-list-item>
                            <v-list-item
                              class="menu-item"
                              @click="
                                viewDocument(
                                  `${fileSystemUrl}/view/${document.filepath_url}`
                                )
                              "
                            >
                              <v-list-item-title
                                >View Document</v-list-item-title
                              >
                            </v-list-item>
                            <v-list-item
                              class="menu-item"
                              @click="removeSupportingDocument(document.id)"
                            >
                              <v-list-item-title
                                >Delete Document</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </div>
                  </v-col>
                  <!-- hidden for now -->
                  <v-col cols="6" class="mt-n4" v-if="false">
                    <div class="d-inline">
                      <div
                        class="records-list"
                        v-for="document in selectedDocuments"
                        :key="document.id"
                        style="display: inline"
                      >
                        <v-menu
                          bottom
                          offset-x
                          origin="center center"
                          transition="scale-transition"
                          v-if="!document.document_route[0].isMainDocument"
                        >
                          <template v-slot:activator="{ on }">
                            <v-tooltip top>
                              <template #activator="{ on: onTooltip }">
                                <v-badge
                                  class="mt-n16"
                                  dot
                                  color="white"
                                  overlap
                                >
                                  <v-icon
                                    v-on="getHandlers(on, onTooltip)"
                                    large
                                    class="mx-1"
                                    color="indigo"
                                  >
                                    mdi-file-document-outline
                                  </v-icon>
                                </v-badge>
                              </template>

                              <span>
                                <v-row style="width: 500px">
                                  <v-col cols="12">
                                    <v-simple-table dense>
                                      <template v-slot:default>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <span
                                                class="
                                                  indigo--text
                                                  font-weight-bold
                                                "
                                                >Remarks:</span
                                              >
                                              {{
                                                document.document_route[0]
                                                  .remarks !== ""
                                                  ? document.document_route[0]
                                                      .remarks
                                                  : "No remarks provided"
                                              }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td colspan="2">
                                              <span
                                                class="
                                                  indigo--text
                                                  font-weight-bold
                                                "
                                                >File URL:</span
                                              >
                                              {{
                                                document.document.filepath_url
                                              }}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </template>
                                    </v-simple-table>
                                  </v-col>
                                </v-row>
                              </span>
                            </v-tooltip>
                          </template>
                          <v-list>
                            <!-- <v-list-item class="menu-item" v-if="parentRouteId">
                                <v-list-item-title @click="attachRouteToParent(document)">Attach Document To Upper Route</v-list-item-title>
                              </v-list-item> -->
                            <v-list-item
                              class="menu-item"
                              @click="openDocumentVersionDialog(document)"
                            >
                              <v-list-item-title
                                >Upload New Version</v-list-item-title
                              >
                            </v-list-item>
                            <v-list-item
                              class="menu-item"
                              @click="
                                viewDocument(
                                  `${fileSystemUrl}/view/${document.filepath_url}`
                                )
                              "
                            >
                              <v-list-item-title
                                >View Document</v-list-item-title
                              >
                            </v-list-item>
                            <v-list-item
                              class="menu-item"
                              @click="deleteSupportingDocument(document.id)"
                            >
                              <v-list-item-title
                                >Delete Document</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </div>
                    <div class="d-inline">
                      <div
                        class="records-list"
                        v-for="record in selectedRecords"
                        :key="record.id"
                        style="display: inline"
                      >
                        <v-menu
                          bottom
                          offset-x
                          origin="center center"
                          transition="scale-transition"
                        >
                          <template v-slot:activator="{ on }">
                            <v-tooltip top>
                              <template #activator="{ on: onTooltip }">
                                <v-badge
                                  class="mt-n16"
                                  dot
                                  color="white"
                                  overlap
                                >
                                  <v-icon
                                    v-on="getHandlers(on, onTooltip)"
                                    class="mx-1"
                                    large
                                    color="green"
                                  >
                                    mdi-file-document-outline
                                  </v-icon>
                                </v-badge>
                              </template>
                              <span>
                                <v-row style="width: 500px">
                                  <v-col cols="12">
                                    <v-simple-table dense>
                                      <template v-slot:default>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <span
                                                class="
                                                  indigo--text
                                                  font-weight-bold
                                                "
                                                >Name:</span
                                              >
                                              {{ record.name }}
                                            </td>
                                            <td>
                                              <span
                                                class="
                                                  indigo--text
                                                  font-weight-bold
                                                "
                                                >Title:</span
                                              >
                                              {{ record.title }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <span
                                                class="
                                                  indigo--text
                                                  font-weight-bold
                                                "
                                                >Date Uploaded:</span
                                              >
                                              {{
                                                formatDocumentDate(
                                                  record.date_uploaded
                                                )
                                              }}
                                            </td>
                                            <td>
                                              <span
                                                class="
                                                  indigo--text
                                                  font-weight-bold
                                                "
                                                >Record Date:</span
                                              >
                                              {{
                                                formatDocumentDate(
                                                  record.record_date
                                                )
                                              }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td colspan="2">
                                              <span
                                                class="
                                                  indigo--text
                                                  font-weight-bold
                                                "
                                                >Remarks:</span
                                              >
                                              {{
                                                record.record_route[0]
                                                  .remarks != ""
                                                  ? record.record_route[0]
                                                      .remarks
                                                  : "No remarks provided"
                                              }}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </template>
                                    </v-simple-table>
                                  </v-col>
                                </v-row>
                              </span>
                            </v-tooltip>
                          </template>

                          <v-list>
                            <!-- <v-list-item class="menu-item" v-if="parentRouteId">
                                  <v-list-item-title @click="attachRouteToParent(document)">Attach Document To Upper Route</v-list-item-title>
                                </v-list-item> -->
                            <v-list-item
                              class="menu-item"
                              @click="
                                viewDocument(
                                  `${fileSystemUrl}/view/${record.filepath_url}`
                                )
                              "
                            >
                              <v-list-item-title>View Record</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-if="loggedInPosition == 'Records Officer'"
                              class="menu-item"
                              @click="deleteRecord(record.id)"
                            >
                              <v-list-item-title
                                >Delete Record</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </div>
                    <div class="d-inline">
                      <div
                        class="records-list"
                        v-for="record in selectedRouteRecordRequests"
                        :key="record.id"
                        style="display: inline"
                      >
                        <v-menu
                          bottom
                          offset-x
                          origin="center center"
                          transition="scale-transition"
                        >
                          <template v-slot:activator="{ on }">
                            <v-tooltip top>
                              <template #activator="{ on: onTooltip }">
                                <v-badge
                                  class="mt-n16"
                                  :color="requestRecordColor(record.status)"
                                  :icon="requestRecordIcon(record.status)"
                                  overlap
                                >
                                  <v-icon
                                    v-on="getHandlers(on, onTooltip)"
                                    class="mx-1"
                                    large
                                    color="grey"
                                  >
                                    mdi-file-document-outline
                                  </v-icon>
                                </v-badge>
                              </template>
                              <span>
                                <v-row style="width: 500px">
                                  <v-col cols="12">
                                    <v-simple-table dense>
                                      <template v-slot:default>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <span
                                                class="
                                                  indigo--text
                                                  font-weight-bold
                                                "
                                                >Date Requested:</span
                                              >
                                              {{
                                                formatDocumentDate(
                                                  record.createdAt
                                                )
                                              }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <span
                                                class="
                                                  indigo--text
                                                  font-weight-bold
                                                "
                                                >Message Request:</span
                                              >
                                              {{ record.message }}
                                            </td>
                                          </tr> 
                                          <tr>
                                            <td>
                                              <span
                                                class="
                                                  indigo--text
                                                  font-weight-bold
                                                "
                                                >Date Uploaded:</span
                                              >
                                              {{
                                                formatDocumentDate(
                                                  record.date_uploaded
                                                )
                                              }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <span
                                                class="
                                                  indigo--text
                                                  font-weight-bold
                                                "
                                                >Status:</span
                                              >
                                              {{ record.status }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td colspan="2">
                                              <span
                                                class="
                                                  indigo--text
                                                  font-weight-bold
                                                "
                                                >Remarks:</span
                                              >
                                              {{ record.remarks }}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </template>
                                    </v-simple-table>
                                  </v-col>
                                </v-row>
                              </span>
                            </v-tooltip>
                          </template>

                          <v-list>
                            <!-- <v-list-item class="menu-item" v-if="parentRouteId">
                                  <v-list-item-title @click="attachRouteToParent(document)">Attach Document To Upper Route</v-list-item-title>
                                </v-list-item> -->
                            <v-list-item
                              class="menu-item"
                              @click="
                                viewDocument(
                                  `${fileSystemUrl}/view/${record.filepath_url}`
                                )
                              "
                            >
                              <v-list-item-title>View Record</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-if="loggedInPosition == 'Records Officer'"
                              class="menu-item"
                              @click="deleteRecord(record.id)"
                            >
                              <v-list-item-title
                                >Delete Record</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </div>
                    <v-menu bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          style="cursor: pointer"
                          class="mx-1 my-1 ml-4 mt-2"
                          light
                          dense
                          color="grey lighten-1"
                          v-on="on"
                          v-bind="attrs"
                          v-if="initiatorRoute.uploadDocumentConfig"
                        >
                          <!-- mdi-file-plus-outline -->
                          mdi-plus-circle
                        </v-icon>
                      </template>
                      <v-list>
                        <v-list-item
                          class="menu-item"
                          @click="addSupportingDocument()"
                        >
                          <v-list-item-title
                            >Upload Supporting Document</v-list-item-title
                          >
                        </v-list-item>

                        <v-list-item
                          class="menu-item"
                          v-if="loggedInPosition == 'Records Officer'"
                          @click="addRouteRecord(initiatorRoute.id)"
                        >
                          <v-list-item-title>Attach Records</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                          class="menu-item"
                          @click="addRouteRequest()"
                        >
                          <v-list-item-title
                            >Request Record Attachment</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-subtitle>
          </v-col>
          <v-col
            cols="12"
            v-show="route_comment_dialog"
            v-if="initiatorRoute.commentAccessConfig"
          >
            <RouteComments
              :comment_dialog="route_comment_dialog"
              :routeId="initiatorRoute.id"
              :accessRoute="initiatorRoute.id"
              :routeType="'mainroute'"
              @closeComments="closeRouteComments"
            />
          </v-col>
        </v-row>
        <v-row class="mt-n10 px-10">
          <v-col cols="12"> </v-col>
        </v-row>
        <v-row class="mb-n5 mt-n8 px-10">
          <v-col cols="3" class="d-inline">
            <v-card-text> </v-card-text>
          </v-col>
          <v-col cols="6">
            <v-card-text> </v-card-text>
          </v-col>
        </v-row>
        <!-- <v-divider v-show="route_comment_dialog" class="px-10"></v-divider> -->
      </v-container>
      <v-progress-linear
        v-show="computedProgress > 0"
        dark
        :value="computedProgress"
        height="20"
        :color="computedProgress > 99 ? 'success' : 'primary'"
      >
        <strong>{{ Math.ceil(computedProgress) }}%</strong>
      </v-progress-linear>
    </v-card>

    <AddReceiverModal
      :dialog="subroute_dialog"
      :parentRoute="parent_route"
      :parentRouteType="parent_route_type"
      @closeDialog="closeReceiverModal"
      :mainRoute="routeId"
      accessFrom="mainroute"
      :initiatorDueDate="datetime_due"
    />

    <AddDocument
      :dialog="document_dialog"
      :routeId="route_document_select"
      :isMainRoute="is_main_route_document"
      :isStandalone="true"
      @closeDialog="closeDocumentModal"
    />

    <!-- <UpdateRouteStatusDialog
      :dialog="route_status_dialog"
      :routeId="parseInt(routeId)"
      :routeCurrentStatus="selected_subroute_status"
      :isSubRoute="false"
      :routeType="'mainroute'"
      @closeDialog="closeRouteStatus"
    /> -->

    <UpdateRouteDetails
      :dialog="update_details_dialog"
      :selectedRoute="update_details_selection"
      @closeDialog="closeRouteUpdateModal"
    />

    <AttachRecordModal
      :dialog="route_record_dialog"
      :routeId="route_record_select"
      :routeType="'mainroute'"
      @closeDialog="closeRouteRecordsModal"
    />

    <RouteLogTrackModal
      :dialog="route_log_dialog"
      :routeId="selected_log_id"
      :routeType="'mainroute'"
      @closeDialog="closeLog"
    />

    <UploadOutputDocumentModal
      :dialog="output_document_dialog"
      :routeId="parseInt(routeId)"
      :document="selectedDocuments[0]"
      :type="upload_document_type"
      routeType="mainroute"
      @closeDialog="closeOutputModal"
    />

    <RouteRequestDialog
      :dialog="record_request_dialog"
      :routeId="parseInt(routeId)"
      routeType="mainroute"
      @closeDialog="closeRouteRequestDialog"
    />
    
    <loading-overlay v-if="loading"/>
    <!-- <UploadDocumentVersionDialog
      :dialog="document_version_dialog"
      :documentId="select_version_id"
      :transactionId="select_version_transaction_id"
      :document="document_versioning"
      :routeId="child.id"
      :routeType="routeType"
      :subRouteIndex="subRouteIndex"
      :parentRouteId="parentRouteId"
      @closeDialog="closeDocumentVersionDialog"
    /> -->
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import moment from "moment";
  import Swal from "sweetalert2";
  import LoadingOverlay from "../common/LoadingOverlay.vue";
  import AddReceiverModal from "../AddReceiverModal";
  import AddDocument from "../AddDocuments";
  // import UpdateRouteStatusDialog from "../sub_routes/UpdateRouteStatusDialog";
  import UpdateRouteDetails from "../UpdateRouteDetails";
  import RouteComments from "./RouteComments";
  import DateCountdown from "../DateCountdown";
  import AttachRecordModal from "../records/AttachRecordModal";
  import RouteLogTrackModal from "./RouteLogTrackModal";
  import UploadOutputDocumentModal from "../documents/UploadOutputDocumentModal";
  import RouteRequestDialog from "../records/RouteRequestDialog";
  import { fileSystemUrl as fsUrl } from "../../config/config.json";

  export default {
    name: "InitiatorRoute",
    props: {
      fetchComplete: Boolean,
      initiatorRoute: Object,
      initiatorAccess: Boolean,
    },
    components: {
      AddReceiverModal,
      AddDocument,
      // UpdateRouteStatusDialog,
      LoadingOverlay,
      UpdateRouteDetails,
      DateCountdown,
      RouteComments,
      AttachRecordModal,
      RouteLogTrackModal,
      UploadOutputDocumentModal,
      RouteRequestDialog,
    },
    data() {
      return {
        fileSystemUrl: fsUrl,
        output_document_dialog: false,
        routeId: this.$route.params.id,
        route_id: "",
        route_status_dialog: false,
        selected_subroute_status: null,
        subroute_dialog: false,
        parent_route: null,
        parent_route_type: "mainroute",
        document_dialog: false,
        route_document_select: null,
        is_main_route_document: true,
        statuses: [],
        show: false,
        route_status: "",
        update_details_dialog: false,
        update_details_selection: null,
        route_comment_dialog: false,
        route_record_dialog: false,
        route_record_select: null,
        route_log_dialog: false,
        selected_log_id: null,
        upload_document_type: "output",
        datetime_due: moment(new Date())
          .toISOString()
          .substr(0, 10),
        record_request_dialog: false,
        loading: false,
        // menu_access: this.child.user_id === this.userAccess ? true : false,
        // subroute_access:
        //   this.isChild === true && this.isInitiator !== true ? true : false,
        // delete_access:
        //   this.isChild === true || this.isInitiator === true ? true : false,
      };
    },
    methods: {
      ...mapActions([
        "addRouteStatus",
        "updateInitiatorComplete",
        "updateInitiatorUndone",
        "removeRouteDocument",
        "removeRouteRecord",
        "addRequestToRoute",
        "fetchInitiatorAttachedDocuments",
        "deleteSupportingDocuments"
      ]),
      removeSupportingDocument(id){
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then((result) => {
          if (result.isConfirmed) {
            this.loading = true;
            this.deleteSupportingDocuments([id]).then(() => {
                this.loading = false
                Swal.fire(
                  "Deleted!",
                  "Your file has been deleted.",
                  "success"
                );
        
            });
          }
        });
      },
      getHandlers() {
        return [...arguments].reduce((seed, item) => {
          const mergedHandlers = { ...item, ...seed };

          return mergedHandlers;
        }, {});
      },
      viewDocument(link) {
        open(link);
      },
      addSubRoute(route_id) {
        this.subroute_dialog = true;
        this.parent_route = route_id;
        this.parent_route_type = "mainroute";
      },
      closeReceiverModal() {
        this.subroute_dialog = false;
        this.parent_route = null;
        this.parent_route_type = "mainroute";
      },
      addRouteDocument(route_id) {
        this.document_dialog = true;
        this.route_document_select = route_id;
        this.is_main_route_document = true;
      },
      closeDocumentModal(val) {
        console.log(val);
        this.document_dialog = false;
      },
      updateStatus() {
        this.route_status_dialog = true;
      },
      closeRouteStatus() {
        this.route_status_dialog = false;
      },
      updateRouteCompeleted(route_id) {
        this.updateInitiatorComplete(route_id)
          .then(result => {
            if (result.error) {
              if (result.status == 400) {
                Swal.fire({
                  icon: "error",
                  title: result.message.details,
                  text: result.message.subtitle,
                });
              } else if (result.status == 403) {
                Swal.fire({
                  icon: "error",
                  title: "Unauthorized",
                  text: result.message.details,
                });
              }
            } else {
              Swal.fire({
                icon: "success",
                title: "Route completed!",
                showConfirmButton: false,
                timer: 1500,
              });

              this.route_status = "Done";
            }
          })
          .catch(err => console.log(err));
      },
      updateRouteDetails(route) {
        this.update_details_selection = route;
        this.update_details_dialog = true;
      },
      closeRouteUpdateModal() {
        this.update_details_dialog = false;
        this.update_details_selection = null;
      },
      openRouteComments() {
        this.show = true;
        this.route_comment_dialog = true;
      },
      closeRouteComments() {
        this.route_comment_dialog = false;
      },
      routeWarning(val) {
        if (val) {
          this.route_status = "Warning";
        }
      },
      addRouteRecord(id) {
        this.route_record_dialog = true;
        this.route_record_select = id;
      },
      closeRouteRecordsModal() {
        this.route_record_dialog = false;
      },
      updateRouteStatusUndone(route_id) {
        this.updateInitiatorUndone(route_id)
          .then(result => {
            if (result.error) {
              if (result.status == 400) {
                Swal.fire({
                  icon: "error",
                  title: "Something went wrong",
                  text: "Unable to do completion",
                });
              } else if (result.status == 403) {
                Swal.fire({
                  icon: "error",
                  title: "Unauthorized",
                  text: "You do not have permissions for this route action",
                });
              }
            } else {
              Swal.fire({
                icon: "success",
                title: "Route completed!",
                showConfirmButton: false,
                timer: 1500,
              });

              this.route_status = "Pending";
            }
          })
          .catch(err => console.log(err));
      },
      closeLog() {
        this.route_log_dialog = false;
      },
      seeTransactionLog(route_id) {
        this.selected_log_id = route_id;
        this.route_log_dialog = true;
      },
      addSupportingDocument() {
        this.output_document_dialog = true;
        this.upload_document_type = "supporting";
      },
      closeOutputModal() {
        this.output_document_dialog = false;
      },
      formatDocumentDate(date) {
        return moment(date).format("LLL");
      },
      requestRecordColor(status) {
        if (status == "Pending") {
          return "grey";
        } else if (status == "Approved") {
          return "green";
        } else {
          return "error";
        }
      },
      requestRecordIcon(status) {
        if (status == "Pending") {
          return "";
        } else if (status == "Approved") {
          return "mdi-check";
        } else {
          return "mdi-close";
        }
      },
      deleteSupportingDocument(val) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then(result => {
          if (result.isConfirmed) {
            const body = {
              document_id: val,
              route_id: this.routeId,
              route_type: "mainroute",
              document_type: "supporting",
              initiator_id: this.routeId,
            };

            this.removeRouteDocument(body).then(result => {
              if (result) {
                Swal.fire("Deleted!", "Your file has been deleted.", "success");
              }
            });
          }
        });
      },
      deleteRecord(record_id) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then(result => {
          if (result.isConfirmed) {
            const body = {
              record_id,
              route_id: this.routeId,
              route_type: "mainroute",
              document_type: "supporting",
              initiator_id: this.routeId,
            };

            this.removeRouteRecord(body).then(result => {
              if (result) {
                Swal.fire("Deleted!", "Your file has been deleted.", "success");
              }
            });
          }
        });
      },
      addRouteRequest() {
        this.record_request_dialog = true;
      },
      closeRouteRequestDialog(val) {
        this.record_request_dialog = false;
        if (val) {
          this.addRequestToRoute(val);
        }
      },
      openDocumentVersionDialog(document) {
        this.document_version_dialog = true;
        this.select_version_id = document.document.id;
        this.select_version_transaction_id = document.document.transaction_id;

        this.document_versioning = {
          document_id: document.document_id,
          transaction_id: document.document.transaction_id,
          document_instance_id: document.id,
        };
      },
    },
    computed: {
      ...mapGetters([
        "selectedRoute",
        "selectedRecords",
        "selectedDocuments",
        "selectedRouteAssignments",
        "getInSequenceRoutes",
        "getNonSequenceRoutes",
        "loggedInPosition",
        "selectedRouteRecordRequests",
        "getListSupportingDocuments"
      ]),
      computedStatuses: function() {
        return this.statuses;
      },
      computedStatusColor: function() {
        var color = "";

        if (this.route_status == "Pending") {
          color = "";
        } else if (this.route_status == "Done") {
          color = "green lighten-4";
        } else if (this.route_status == "Overdue") {
          color = "red lighten-4";
        } else if (this.route_status == "Warning") {
          color = "yellow lighten-4";
        } else {
          color = "";
        }
        return color;
      },
      computedProgress: function() {
        let percentage = 0;

        if (this.selectedRouteAssignments) {
          const totalSubroutes = this.selectedRouteAssignments.length;

          let doneCount = 0;

          this.selectedRouteAssignments.forEach(element => {
            if (element.status == "Done") doneCount++;
          });

          percentage = Math.floor((doneCount / totalSubroutes) * 100);
        }
        return percentage;
      },
    },
    created() {

      if (this.fetchComplete) {
        this.statuses = this.initiatorRoute.statuses;
        this.route_status = this.initiatorRoute.status;
        this.datetime_due = moment(this.initiatorRoute.datetime_due)
          .toISOString()
          .substr(0, 10);
      }
      this.fetchInitiatorAttachedDocuments(this.initiatorRoute.document_instances[0].document_id).then(()=> {
        console.log(this.getListSupportingDocuments)
      })
    },
  };
</script>

<style scoped>
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .list-item {
    cursor: pointer;
    font-size: 14px;
  }

  .no-background-hover::before {
    background-color: transparent !important;
  }

  .menu-item {
    cursor: pointer;
  }
</style>
